import React, {useState, useEffect} from 'react';
import AdminPage from './AdminPage';
import TeacherPage from './TeacherPage';
import StaticNav from '../common/StaticNav';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { request } from '../../redux/actions/genericAction';
import { Redirect} from 'react-router-dom';

const ProfilePage = ({isAdmin, database, request}) => {
  const [hasDatabaseData, sethasDatabaseData] = useState(true);
  useEffect(() => {
    if(!database['getCustomer'])
      return sethasDatabaseData(false);
  });

  if (!hasDatabaseData) { return <Redirect to='/' />;}  

  return (
  <div>
      <br/>
      <StaticNav currentTopic={'Account'}/>  
      <br/>              
      {isAdmin && <AdminPage pageState={(database['getCustomer'])?({customer:database['getCustomer'].data, request}):{}}/>}
      {!isAdmin && <TeacherPage pageState={{database, request}}/>}
  </div>
  );
};

ProfilePage.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
};

const mapStateToProps = state => {
  return {
      isAdmin: (state.dashboardReducer.login === 'Admin'),
      database: state.genericReducer
 };
};

export default connect(mapStateToProps,{request})(ProfilePage);